module.exports = __webpack_public_path__ + "img/res-icon.44c1845d.png";